import React from 'react';
import { NavLink, NavLinkRenderProps } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const getNavLinkClass = ({ isActive }: NavLinkRenderProps): string => isActive ? 'active' : '';

export function AdminMenu(): JSX.Element | null {
  const { user } = useAuth();

  if (!user?.isAdmin) {
    return null;
  }

  return (
    <nav className="admin-menu">
      <NavLink to="/admin" end className={getNavLinkClass}>
        Dashboard
      </NavLink>
      <NavLink to="/admin/organizations" className={getNavLinkClass}>
        Organisationen
      </NavLink>
      <NavLink to="/admin/access-codes" className={getNavLinkClass}>
        Zugangscodes
      </NavLink>
      {user.isSuperAdmin && (
        <NavLink to="/admin/admins" className={getNavLinkClass}>
          Admins
        </NavLink>
      )}
      <NavLink to="/admin/settings" className={getNavLinkClass}>
        Einstellungen
      </NavLink>
    </nav>
  );
}

export default AdminMenu;
